import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomIcon, { IconName } from "src/components/Icon/Icon";
import * as S from "../../constants/StringConstants";
import "./CopyToClipboard.scss";

interface CopyToClipboardButtonProps {
  textToCopy: string;
}

const CopyToClipboard: React.FC<CopyToClipboardButtonProps> = ({ textToCopy }) => {
  const [copied, setCopied] = useState<boolean>(false);
  const timeoutRef = useRef<number | null>(null);

  const handleCopy = useCallback(() => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setCopied(true);

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = window.setTimeout(() => {
          setCopied(false);
        }, 2000);
      })
      .catch(err => {
        console.error("Could not copy text: ", err);
      });
  }, [textToCopy]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <span className="copy-to-clipboard-button-container" onClick={handleCopy}>
      {!copied && (
        <span className="copy-icon-container" title={S.PB_COPY_TOOLTIP}>
          <CustomIcon name={IconName.Copy} size="24px" />
        </span>
      )}
      {copied && <span className="copy-to-clipboard-button-container__message">{S.PB_COPY_TOOLTIP_FEEDBACK}</span>}
    </span>
  );
};

export default CopyToClipboard;
